<template>
  <div class="">
    <div class="section-title" style="text-align: center; margin: 40px 0;">
      Płatność
    </div>
    <v-container class="container mt-10" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card">
            <v-container v-if="packageData" class=" ">
              <div v-if="packageData.active">
                <PaymentForm
                  :profile="profile"
                  :submitAction="'payment/createSequencingWorkshopOrder'"
                  :submitParams="{
                    sequencingWorkshopId: $route.params.id,
                    type:
                      packageData && packageData.type
                        ? packageData.type
                        : 'STANDARD',
                    isExtension: $route.query.extension ? true : false,
                    extensionCode: $route.query.extension,
                  }"
                />
              </div>
              <div v-else>
                <p style="color:#8B857D; margin-bottom: 40px;">
                  Zajęcia obecnie są nieaktywne. Spróbuj ponownie bliżej ich
                  rozpoczęcia.
                </p>

                <a
                  href="https://dagajoga.pl/index.php/zajecia-na-zywo/"
                  class="primary-button"
                  >OK</a
                >
              </div>
            </v-container>

            <v-container v-else class="mb-12">
              <h3 class="text-center" style="padding: 1rem">
                Przepraszamy, te warsztaty nie są już dostępne
              </h3>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PaymentForm from "../components/forms/PaymentForm.vue";
import axios from "../axios";
export default {
  metaInfo: {
    title: "Dagajoga kurs online - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "SequencingWorkshopPayment",
  components: {
    PaymentForm,
  },
  data: () => ({}),
  computed: {
    packageData: function() {
      return this.$store.getters["sequencingWorkshops/getSequencingWorkshop"];
    },
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
  },
  async created() {
    this.resetData();
    await this.$store.dispatch(
      "sequencingWorkshops/fetchSequencingWorkshop",
      this.$route.params.id
    );
    if (this.$route.query.extension) {
      const response = await axios.get(
        `sequencingWorkshops/${this.$route.params.id}/checkIsAllowedToExtend`,
        { params: { code: this.$route.query.extension } }
      );
      const isAllowed = response.data;
      if (!isAllowed) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message: "Nie masz możliwości przedłużenia warsztatów",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        this.$router.push({
          name: "SequencingWorkshops",
          params: {
            id: this.$route.params.id,
          },
        });
      }
    }
  },
  async mounted() {
    await this.$store.dispatch("auth/fetchUserProfile");
    const token = window.localStorage.getItem("userToken");
    if (!token) {
      this.$store.dispatch(
        "snackbar/setSnackbar",
        {
          color: "red",
          icon: "exclamation-triangle",
          message:
            "Zakup warsztatów z sekwencjonowania dostępny jest wyłącznie dla zalogowanych użytkowników",
        },
        { root: true }
      );
      this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
      this.$router.push({
        name: "Auth",
        params: {
          previousPath: `/warsztaty-z-sekwencjonowania/platnosc/${this.$route.params.id}`,
        },
      });
    }
  },
  destroyed() {
    this.reset();
  },
  methods: {
    resetData() {
      this.$store.commit("payment/SET_INIT_VALUES");
    },
    reset() {
      this.resetData();
    },
  },
};
</script>

<style scoped>
.reset {
  text-transform: uppercase;
  cursor: pointer;
}
.submit-button {
  background-color: #8b857d !important;
  border-radius: 20px;
  font-size: 1.1rem;
  color: #d9d9d9;
  margin: auto;
  display: flex;
  justify-content: center;
}
.card {
  background: #d9d9d9;
  border-radius: 20px !important;
  box-shadow: 0px 0px 100px 25px #b6afa5 !important;
  color: #8b857d;
}
.agreements p {
  font-size: 12px;
}
.card{
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px !important;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}
</style>
